import React from 'react';
import PropTypes from 'prop-types';
import {Avatar, Popover, Button} from 'antd';
import classNames from 'classnames';

import AppPinButton from './AppPinButton';

import styles from './NewAppItem.module.less';
import NewAppPinButton from '@/page/HomePage/NewAppPinButton';

export default function NewAppItem({
    pined,
    imageUrl,
    title,
    description,
    big = false,
    className,
    onPinedClick,
}) {
    const container = classNames(styles.container, {[styles.bigContainer]: big}, className);

    return (
        <div className={container}>
            <NewAppPinButton
                pined={pined}
                big={big}
                className={styles.btnPin}
                onClick={onPinedClick}
            />
            <div className={styles.imageWrap}>
                <Avatar
                    shape="square"
                    size={big ? 96 : 32}
                    src={imageUrl}
                    style={{borderRadius: 2}}
                />
            </div>
            <div className={styles.title}>
                <Popover content={title}>
                    <Button type={'text'} style={{padding: 0, margin: 0}}>
                        {title.length <= 8 ? title : title.substr(0, 8) + '...'}
                    </Button>
                </Popover>
            </div>
            <div className={styles.description}>
                <Popover content={description}>
                    <Button type={'text'} style={{padding: 0, margin: 0}}>
                        {(description.length <= 10
                            ? description
                            : description.substr(0, 10) + '...') || '无应用描述'}{' '}
                    </Button>
                </Popover>
            </div>
        </div>
    );
}

NewAppItem.propTypes = {
    big: PropTypes.bool,
    pined: PropTypes.bool,
    imageUrl: PropTypes.string,
    title: PropTypes.string.isRequired,
    description: PropTypes.string.isRequired,
    className: PropTypes.string,
    onPinedClick: PropTypes.func,
};
